import type { ReactNode } from 'react';
import * as Icons from 'lucide-react';

/** PNG paths aligned with LeftNavigationV2 customAppIcons */
const CUSTOM_APP_ICON_PATHS: Record<string, string> = {
  analytics: '/Analyticsappicon.png',
  projects: '/Projectsappicon.png',
  calendar: '/Calenderappicon.png',
  crm: '/CRMappicon.png',
  proposals: '/Proposalsappicon.png',
  tasks: '/Bookingsappicon.png',
  inventory: '/Inventoryappicon.png',
  expenses: '/Expensesappicon.png',
  payroll: '/Timesheetsappicon.png',
  teams: '/Teamsappicon.png',
  invoices: '/Invoicesappicon.png',
  automations: '/Automateappicon.png',
  services: '/Servicesappicon.png',
  customers: '/Customersappicon.png',
  marketing: '/Marketingappicon.png',
  'gift-cards': '/Giftcardsappicon.png',
  messages: '/Messagesappicon.png',
  bookings: '/Bookingsappicon.png',
  products: '/Storeappicon.png',
  'mobile-calendar': '/Fieldproappicon.png',
  'm-calendar': '/Fieldproappicon.png',
};

export function isCustomAppIcon(appSlug?: string): boolean {
  return !!appSlug && appSlug in CUSTOM_APP_ICON_PATHS;
}

export function getAppIcon(
  iconName: string,
  size: string = 'h-5 w-5',
  appSlug?: string,
  options?: { tile?: boolean }
): ReactNode {
  try {
    const customPath = appSlug ? CUSTOM_APP_ICON_PATHS[appSlug] : undefined;
    if (customPath) {
      return (
        <img
          src={customPath}
          alt={appSlug ?? 'App'}
          className={
            options?.tile
              ? `${size} object-cover rounded-[22%]`
              : `${size} object-contain`
          }
        />
      );
    }

    const Icon = Icons[iconName as keyof typeof Icons] || Icons.HelpCircle;
    return <Icon className={size} />;
  } catch {
    return <Icons.HelpCircle className={size} />;
  }
}
